import React, { useState, useEffect } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { GetActiveEmployeeApi } from "../employee/employeeAction";
import { AddSTRecivingApi } from "./STAction";
import { appendNonSignificantZeros, GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const STReciving = (props) => {
    const [employeeId, setEmployeeId] = useState();
    const [employeeName, setEmployeeName] = useState();
    const [date, setDate] = useState();
    const [accType, setAccType] = useState();
    const [amount, setAmount] = useState();
    const [deduction, setDeduction] = useState();
    const [description, setDescription] = useState();


    const SaveSTReceving = () => {
        props.AddSTRecivingApi({
            employeeId: employeeId,
            date: date,
            accType: accType,
            creditValue: Number(amount),
            deductionValue: Number(amount),
            description: description,
        },
            showSuccessAlert,
            showErrorAlert,
        );
        setEmployeeId("")
        setEmployeeName("")
        setDate("")
        setAccType("")
        setAmount("")
        setDeduction("")
        setDescription("")
    };

    const getEmployeeList = _.isEmpty(props.activeEmployeeList) ? [] : props.activeEmployeeList.map((x) => {
        let data = { value: x._id, label: `${appendNonSignificantZeros(x.employeeName)}-${x.fatherName}-${x.cnic}` };
        return data
    })
    const handleChangeEmployee = (selectedOption) => {
        setEmployeeId(selectedOption.value);
        setEmployeeName(selectedOption.label);
    };

    useEffect(() => {
        props.GetActiveEmployeeApi();
        props.setHeading("Receive Short Term Advance")
    }, []);

    return (
        <>
            {props.isFetchingActiveEmployeeData || props.isAddingSTReciving ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Employee *</b></Form.Label>
                                <Select
                                    placeholder="Select Employee"
                                    onChange={handleChangeEmployee}
                                    options={getEmployeeList}
                                    isDisabled={_.isEmpty(getEmployeeList)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Date"
                                    onChange={(e) => setDate(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Payment Method *</b> </Form.Label>
                                <Select
                                    placeholder="Payment Method"
                                    onChange={(selectedOption) => { setAccType(selectedOption.label) }}
                                    options={[{ value: "Cash", label: "Cash" }, { value: "Bank", label: "Bank" }]}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Amount *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Amount"
                                    onChange={(e) => { setAmount(e.target.value); setDeduction(e.target.value) }}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Deduction Value *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Deduction Value"
                                    defaultValue={deduction}
                                    onBlur={(e) => setDeduction(e.target.value)}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Description</b></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Description"
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(employeeName) || _.isEmpty(date) || _.isEmpty(accType) || _.isEmpty(amount) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { SaveSTReceving(); }}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddSTRecivingApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddSTRecivingApi(data, showSuccessAlert, showErrorAlert)),
        GetActiveEmployeeApi: () => dispatch(GetActiveEmployeeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingSTReciving: state.STReducer.isAddingSTReciving,
    activeEmployeeList: state.EmployeeReducer.activeEmployeeList,
    isFetchingActiveEmployeeData: state.EmployeeReducer.isFetchingActiveEmployeeData,
});

export default connect(mapStateToProps, mapDispatchToProps)(STReciving);